'use strict'

document.addEventListener('DOMContentLoaded', function() {

  function getCookie(name) {
      let value = "; " + document.cookie;
      let parts = value.split("; " + name + "=");
      if (parts.length === 2) return parts.pop().split(";").shift();
  }

  var token = getCookie('token');
  
  if (token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      var payload = JSON.parse(jsonPayload);
      var email = payload.email;
      
      console.log(email); // Do something with the email
      document.querySelector('.user-menu').style.display = 'inline-block';
      document.querySelector('#sign-up').style.display = 'none';
      document.querySelector('#log-in').style.display = 'none';
  } else {
      console.log("Token is not defined");
      // Handle the case where the token is not available
      document.querySelector('.user-menu').style.display = 'none';
      document.querySelector('#my-account').style.display = 'none';
  }

});

jQuery(document).ready(function ($) {

  // Sticker Header 
  $(window).scroll(function () {
    if ($(this).scrollTop() > 30) {
      $('.site-header').addClass("is-sticky");
    } else {
      $('.site-header').removeClass("is-sticky");
    }
  });

  // User Menu Dropdown
  if($('.user-menu').length > 0) {

    // Avatar Initials
    const username = $('.user-name').text().split(' ');
    $('.user-avatar').text( 
      (username[0] ? username[0].charAt(0).toUpperCase() : '') + 
      (username[1] ? username[1].charAt(0).toUpperCase() : '') + 
      (username[2] ? username[2].charAt(0).toUpperCase() : '')
    );
    
    // User Menu Dropdown
    $('.user-avatar-dropdown').on('click', function(e) {
      e.preventDefault()
      $('.user-dropdown').toggleClass('active')
      if($('.user-dropdown').hasClass('active')) {
        $('.user-dropdown').slideDown({
          start: function () {
            $(this).css({
              display: "flex"
            })
          }
        })
      } else {
        $('.user-dropdown').slideUp()
      }
    });

    // If user clicks outside of the dropdown, close it
    $(document).on('click', function(e) {
      if (!$(e.target).closest('.user-menu').length) {
        $('.user-dropdown').slideUp()
      }
    });

  }

  //Video play button  
  if($('.wp-block-video.has-custom-cursor').length > 0) {
    let vidCustomCursor = $('.wp-block-video.has-custom-cursor');
    
    $('.wp-block-video.has-custom-cursor').append('<div class="video-cursor"></div>');
    $('.wp-block-video.has-custom-cursor').append('<div class="video-overlay"></div>');
    
    // vidCustomCursor.on('mouseover', function(e) {
    //   $(this).find('.video-cursor').addClass('entering')
    //   setTimeout(() => {
    //     $(this).find('.video-cursor').removeClass('entering')
    //   }, 400);
    // });

    // let mouseX = 0
    // let mouseY = 0

    // $(vidCustomCursor).on('mousemove', function(e) {
    //   if($(window).width() >= 768) {
    //     mouseX = e.offsetX
    //     mouseY = e.offsetY

    //     $(this).find('.video-cursor').css('top', mouseY)
    //     $(this).find('.video-cursor').css('left', mouseX)
    //   }
    // });

    $('.wp-block-video.has-custom-cursor').on('mouseleave', function(e) {
      $(this).find('.video-cursor').addClass('exiting')
      setTimeout(() => {
        $(this).find('.video-cursor').removeClass('exiting')
      }, 400);
      
      videoCursorPosition()
        
    });
    let vid = $('.wp-block-video.has-custom-cursor video');		

    $(document).on('click', '.wp-block-video.has-custom-cursor .video-overlay', function(e) {
      e.preventDefault()
      let videoElement = vid.get(0);
      let isPause = videoElement.paused
      
      if(isPause) {
        $('.video-cursor').addClass('playing')
        $('.video-cursor').addClass('shrinking')
        setTimeout(() => {
          $('.video-cursor').removeClass('shrinking')
        }, 400);
        isPause = false
        videoElement.play()
      } else {
        $('.video-cursor').removeClass('playing')
        $('.video-cursor').addClass('expanding')
        setTimeout(() => {
          $('.video-cursor').removeClass('expanding')
        }, 400);
        isPause = true
        videoElement.pause()
      }
      
      if($(window).width() < 768) videoCursorPosition()

    })

    //detect video completion
    $('.wp-block-video.has-custom-cursor video').on('ended',function() {
      $('.video-cursor').removeClass('playing')
      videoCursorPosition()
    })

  }

  //Update Cursor Position
  function videoCursorPosition() {
    let pauseLeft = '50px'
    let pauseTop = '50px'
    if($(window).width() < 768) {
      pauseLeft = '35px'
      pauseTop = '35px'
    }

    if( !$('.video-cursor').hasClass('playing') ) {
      $('.video-cursor').css({
        'left': '50%',
        'top': '50%'
      });
    } else {
      $('.video-cursor').css({
        'left': pauseLeft,
        'top': pauseTop
      });
    }	
  }

  // custom menu toggle
  if( $('.custom-menu').length > 0 ) {
    $('.custom-menu .menu li.menu-item-has-children > a').each(function() {
      $(this).append('<span class="wp-block-navigation__submenu-icon"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true" focusable="false"><path d="M1.50002 4L6.00002 8L10.5 4" stroke-width="1.5"></path></svg></span>');
      $(this).next('.sub-menu').hide();
    }); 
    $(document).on('click', '.custom-menu .menu li.menu-item-has-children a .wp-block-navigation__submenu-icon', function(e) {
      e.preventDefault()
      $(this).parent().toggleClass('open').next('.sub-menu').slideToggle();
    });
  }

  if( $('.widget_nav_menu').length > 0 ) {

    $('.widget_nav_menu').each(function() {
      $(this).find('.menu-item-has-children > a').after('<span class="sub-menu-toggle"><svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.20521 8.41052C7.20521 8.41052 7.93367 8.72307 8.14181 8.41052L15.0105 1.53462C15.0105 1.53462 15.3227 0.805045 15.0105 0.596676C14.6983 0.388307 14.282 0.284122 14.0739 0.596676L7.72544 6.95178L1.37729 0.596676C1.37729 0.596676 0.648839 0.284122 0.440698 0.596676C0.232557 0.90923 0.128487 1.32625 0.440698 1.53462L7.30939 8.41052H7.20521Z" fill="white"/></svg></span>');
    });

    $('.sub-menu-toggle').on('click', function(e) {
      e.preventDefault()
      $(this).toggleClass('is-open').next('.sub-menu').slideToggle()
    });

  }

  // limit explore-grid post title text 
  if($('.explore-grid-outer .wp-block-post-title a').length > 0) {
    $('.explore-grid-outer .wp-block-post-title a').each(function() {
      let text = $(this).text();
      if(text.length > 50) {
        $(this).text(text.substring(0, 50) + '...')
      }
    });
  }

})